export default __webpack_public_path__ + "static/media/three.59fab205.svg";